// src/components/FAQ.js
import React, { useState } from 'react';
import { Icons } from './Icons';

const faqs = [
  { q: 'Как добавить бота в чат?', a: 'Перейдите по ссылке "Добавить бота" на сайте, выберите ваш чат и дайте боту права администратора.' },
  { q: 'Нужно ли платить за использование?', a: 'Нет, Atri Bot полностью бесплатен для всех функций.' },
  { q: 'Какие права нужны боту?', a: 'Для полноценной работы боту нужны права: удаление сообщений, блокировка участников, ограничение прав, отправка сообщений.' },
  { q: 'Как получить доступ к онлайн-панели?', a: 'Напишите /onlinepanel в чате, где вы администратор. Бот пришлёт секретный код в личные сообщения.' },
  { q: 'Что делать, если бот не отвечает?', a: 'Проверьте, что бот имеет права администратора и не был удалён из чата. Используйте /help для создания тикета.' },
  { q: 'Как работает антирейд?', a: 'Бот отслеживает количество вступлений за 15 секунд. При превышении порога (зависит от чувствительности) активируется защита.' },
  { q: 'Можно ли отключить авто-удаление сообщений?', a: 'Да, в настройках есть параметр autoDeleteEnabled для полного контроля.' },
  
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section id="faq" className="faq">
      <div className="container">
        <div className="section-header">
          <h2>Часто задаваемые вопросы</h2>
          <p>Ответы на самые популярные вопросы</p>
        </div>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${openIndex === index ? 'open' : ''}`}
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              <div className="faq-question">
                <span>{faq.q}</span>
                <span className="faq-icon">
                  {openIndex === index ? <Icons.ArrowDown /> : <Icons.ArrowRight />}
                </span>
              </div>
              <div className="faq-answer">
                <p>{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ;